/**
 * Cookie操作工具类
 */

/**
 * 设置Cookie
 * @param name Cookie名称
 * @param value Cookie值
 * @param days 过期天数
 * @param path Cookie路径，默认为'/'
 * @param domain Cookie域
 * @param secure 是否仅HTTPS
 */
export const setCookie = (
  name: string,
  value: string,
  days?: number,
  path: string = '/',
  domain?: string,
  secure: boolean = false
): void => {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = `; expires=${date.toUTCString()}`;
  }

  let cookie = `${encodeURIComponent(name)}=${encodeURIComponent(value)}${expires}; path=${path}`;
  
  if (domain) {
    cookie += `; domain=${domain}`;
  }
  
  if (secure) {
    cookie += '; secure';
  }

  document.cookie = cookie;
};

/**
 * 获取Cookie值
 * @param name Cookie名称
 * @returns Cookie值或null
 */
export const getCookie = (name: string): string | null => {
  const nameEQ = `${encodeURIComponent(name)}=`;
  const cookies = document.cookie.split(';');
  
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i];
    while (cookie.charAt(0) === ' ') {
      cookie = cookie.substring(1, cookie.length);
    }
    if (cookie.indexOf(nameEQ) === 0) {
      return decodeURIComponent(cookie.substring(nameEQ.length, cookie.length));
    }
  }
  return null;
};

/**
 * 删除Cookie
 * @param name Cookie名称
 * @param path Cookie路径，默认为'/'
 * @param domain Cookie域
 */
export const removeCookie = (
  name: string,
  path: string = '/',
  domain?: string
): void => {
  setCookie(name, '', -1, path, domain);
};

/**
 * 检查Cookie是否存在
 * @param name Cookie名称
 * @returns 是否存在
 */
export const hasCookie = (name: string): boolean => {
  return getCookie(name) !== null;
};